// extracted by mini-css-extract-plugin
export var component = "SearchTeaser-module--component--5Xur8";
export var content = "SearchTeaser-module--content--hs5ZY";
export var excerpt = "SearchTeaser-module--excerpt--niF02";
export var hasImage = "SearchTeaser-module--hasImage--i-eEf";
export var image = "SearchTeaser-module--image--Y7EaP";
export var meta = "SearchTeaser-module--meta--blWbH";
export var teaserHeader = "SearchTeaser-module--teaserHeader--2HYrS";
export var title = "SearchTeaser-module--title--2wwvI";